import { ActionIcon } from '@mantine/core';
import { useTimeout } from '@mantine/hooks';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

import { copyToClipboard } from '@mygpt/app';

export const CopyButton = (props: { apiKey?: string }) => {
  const apiKey = props.apiKey || '';
  const [copied, setCopied] = useState(false);
  const { clear, start } = useTimeout(() => setCopied(false), 2000);

  useEffect(() => {
    return clear;
  }, [apiKey]);

  return (
    <ActionIcon
      className="mr-1"
      onClick={() => {
        copyToClipboard(apiKey);
        setCopied(true);
        start();
      }}
    >
      {copied ? <IconCheck size="1rem" /> : <IconCopy size="1rem" />}
    </ActionIcon>
  );
};
